import { authConfig } from "../apiConfig";

//FRO GET PRIVILEGES BY ROLE ID

export const get_privilages_list = async (payload) => {
    try {
        const response = await authConfig.post(`getRolePrivileMapList`, payload);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const update_role_privilages = async (data) => {
    try {
        const response = await authConfig.post(`rolePrivilegeMap`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response?.data;
    } catch (error) {
        throw error;
    }
};
export const get_privilages = async () => {
    
    try {
        const response = await authConfig.post(`getUserPrivileges`);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};